import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { editClientApi } from "../../Services/EditClientService/EditclientApi"; //  Import your edit API
import AlertMessage from "../AlertMessage/AlertMessage";
import PhoneInput from "react-phone-input-2";

interface AddclientsProps {
  visible: boolean;
  onClose: () => void;
  rowData?: any;
  clientId?: string;
  data?: any; // Add this line to accept the data prop
}

const validationSchema = Yup.object({
  name: Yup.string().trim().required("Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  phone: Yup.string()
    .required("Phone is required")
    .matches(/^\d{10,15}$/, "Phone number is invalid"),
  address: Yup.string().trim().required("Address is required"),
});

const Editclient: React.FC<AddclientsProps> = ({
  visible,
  onClose,
  rowData,
  clientId,
  data,
}) => {
  const [user, setUser] = useState<string>("");

  useEffect(() => {
    const userDataString = localStorage.getItem("user");
    if (userDataString) {
      try {
        const userData = JSON.parse(userDataString);
        setUser(userData.userId);
      } catch (err) {
        console.error("Error parsing user data:", err);
      }
    }
  }, []);

  if (!visible) return null;

  //  Submit updated client data using editClientApi
  const submitClientData = async (values: {
    name: string;
    email: string;
    phone: string;
    address: string;
  }) => {
    try {
      const payload = {
        clientId: rowData?.clientId || "", // Use ID from selected row
        name: values.name.trim(),
        email: values.email,
        phoneNumber: values.phone,
        address: values.address.trim(),
        adminId: user, // from localStorage
      };

      console.log("Submitting Edit Payload:", payload);

      const result = await editClientApi(payload); //  Calling your edit API

      AlertMessage({
        text: "Client updated successfully!",
        type: "success",
      });

      console.log("Edit API Response:", result);
      onClose();
    } catch (error) {
      console.error("Failed to update client:", error);
      AlertMessage({
        text: "Failed to update client!",
        type: "error",
      });
    }
    finally {
      data(); // Refresh data after edit
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "24px",
          borderRadius: "16px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
          width: "600px",
          position: "relative",
        }}
      >
        <span
          onClick={onClose}
          style={{
            position: "absolute",
            top: "8px",
            right: "12px",
            fontSize: "var(--font-size-3xl)",
            cursor: "pointer",
          }}
        >
          &times;
        </span>
        <h2 style={{ fontSize: "var(--font-size-2xl)", fontWeight: 600, marginBottom: "16px" }}>
          Edit Client
        </h2>

        <Formik
          initialValues={{
            name: rowData?.name || "",
            email: rowData?.email || "",
            phone: rowData?.phoneNumber || "",
            address: rowData?.address || "",
          }}
          enableReinitialize
          validationSchema={validationSchema}
          onSubmit={(values, { resetForm }) => {
            submitClientData(values);
            resetForm();
          }}
        >
          {({ values, setFieldValue, isSubmitting }) => (
            <Form
              style={{ display: "flex", flexDirection: "column", gap: "12px" }}
            >
              {/* Name */}
              <label>
                Name <span className="start">*</span>
              </label>
              <Field
                name="name"
                type="text"
                placeholder="Enter name"
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  borderRadius: "6px",
                }}
              />
              <ErrorMessage
                name="name"
                render={(msg) => (
                  <div style={{ color: "red", fontSize: "var(--font-size-sm)" }}>{msg}</div>
                )}
              />

              {/* Email */}
              <label>
                Email <span className="start">*</span>
              </label>
              <Field
                name="email"
                type="email"
                placeholder="Enter email"
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  borderRadius: "6px",
                }}
              />
              <ErrorMessage
                name="email"
                render={(msg) => (
                  <div style={{ color: "red", fontSize: "var(--font-size-sm)" }}>{msg}</div>
                )}
              />

              {/* Phone */}
              <label>
                Phone <span className="start">*</span>
              </label>
              <PhoneInput
                country={"us"} // default country
                value={values.phone}
                onChange={(phone: any) => setFieldValue("phone", phone)}
                // buttonStyle={{ display: 'none' }}
                inputStyle={{
                  width: "100%",
                  borderRadius: "6px",
                  padding: "8px",
                  paddingLeft: "58px",
                  border: "1px solid #ccc",
                }}
                specialLabel=""
              />
              <ErrorMessage
                name="phone"
                render={(msg) => (
                  <div style={{ color: "red", fontSize: "var(--font-size-sm)" }}>{msg}</div>
                )}
              />

              {/* Address */}
              <label>
                Address <span className="start">*</span>
              </label>
              <Field
                as="textarea"
                name="address"
                placeholder="Enter address"
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  borderRadius: "6px",
                  width: "100%",
                  height: "100px",
                  resize: "none",
                }}
              />
              <ErrorMessage
                name="address"
                render={(msg) => (
                  <div style={{ color: "red", fontSize: "var(--font-size-sm)" }}>{msg}</div>
                )}
              />

              {/* Buttons */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                  marginTop: "10px",
                }}
              >
                <button
                  type="button"
                  onClick={onClose}
                  style={{
                    flex: 1,
                    backgroundColor: "#7f8081ff",
                    color: "white",
                    padding: "10px",
                    borderRadius: "6px",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  style={{
                    flex: 1,
                    backgroundColor: "var(--color-brand)",
                    color: "white",
                    padding: "10px",
                    borderRadius: "6px",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  {isSubmitting ? "Submitting..." : "Update"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default Editclient;
